import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=b875bb94&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=b875bb94&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b875bb94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b875bb94')) {
      api.createRecord('b875bb94', component.options)
    } else {
      api.reload('b875bb94', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=b875bb94&scoped=true", function () {
      api.rerender('b875bb94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Login.vue"
export default component.exports